import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/core/services/app.service';
import { ToastrService } from 'ngx-toastr';
import { EditPlanificationComponent } from './edit-planification/edit-planification.component';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import swal from 'sweetalert2';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-declencher',
  templateUrl: './declencher.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .dark-modal .modal-content {
      background-color: #292b2c;
      color: white;
    }
    .dark-modal .close {
      color: white;
    }
    .light-blue-backdrop {
      background-color: #5cb3fd;
    }
`]
})

export class DeclencherComponent implements OnInit {

  public loaderText: string;
  public libelle: string;
  public date_debut: string;
  public date_fin: string;
  public annee: any;
  public day;
  public month;
  public idCampagne: any;
  public listCampagne: any;
  public key = 'libelle';
  public reverse = false;
  public p = 1;
  public filter: string;

  constructor(
    private modalService: NgbModal,
    private title: Title,
    private http: HttpClient,
    private _toastr: ToastrService,
    private storage: LocalStorageService,
    private _loading: LoadingBarService,
    private _router: Router,
    public activeModal: NgbActiveModal,
    private _app: AppService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.title.setTitle('Initialisation EIA | HR Performance');
    this.getAllCampagne();
    this.getDateOfDay();
    // this.getListeAnnee();
  }


  public getDateOfDay() {
    const d = new Date();
    const day = d.getDate();
    const month = d.getMonth() + 1;
    this.month = month;
    day < 10 ? this.day = '0' + day : this.day = day;
    month < 10 ? this.month = '0' + month : this.month = month;
    const year = d.getFullYear();
    this.date_debut = year + '-' + this.month + '-' + this.day;
    this.date_fin = year + '-' + this.month + '-' + this.day;
    this.annee = year;
  }


  editPlanificationCampagne(data) {
    const modalRef = this.modalService.open(EditPlanificationComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
    modalRef.componentInstance.planification = data;
  }

  addCampagne(content) {
    this.activeModal = this.modalService.
      open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false, centered: true });
  }

  getListeAnnee() {
    this._app.getData('campagne/last')
      .subscribe(
        res => {
          if (res.error === false) {
            this._loading.stop();
            this.annee = parseInt(res.data.annee);
            this.idCampagne = res.data.id;
          } else {
            swal.fire({
              title: 'HR PERF',
              type: 'error',
              text: res.message,
              showCancelButton: false,
              confirmButtonText: 'ok'
            });
          }
        },
        err => {
          this._toastr.error(err.error.message);
          this._loading.stop();
        }
      );
  }

  deleteCampagne(item) {
    swal.fire({
      title: `Vous allez supprimer la campagne ${item.libelle}`,
      text: 'cette action est irréversible !!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FD7E14',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Non, Annuler!',
      confirmButtonText: 'Oui, supprimer-la!'
    }).then((result) => {
      if (result.value) {
        this._loading.start();
        this.loaderText = 'Suppression de la campagne en cours';
        this._app.deleteData(`campagne/${item.id}/delete`)
          .subscribe(
            res => {
              if (res.error === false) {
                this._toastr.success(res.message);
                this.getAllCampagne();
                this._loading.stop();
              } else {
                this._toastr.error(res.message);
                this._loading.stop();
              }
            }, err => {
              this._loading.stop();
              this._toastr.error(err.error.message);
            }
          );
      }
    });
  }

  openCampagne(item) {
    swal.fire({
      title: `Vous allez ouvrir la campagne ${item.libelle}`,
      text: 'Assurez-vous d\'avoir chargé correctement les données des agents !!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FD7E14',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Non, Annuler!',
      confirmButtonText: 'Oui, ouvrir!'
    }).then((result) => {
      if (result.value) {
        this._loading.start();
        this.loaderText = 'Ouverture de la campagne en cours';
        const data = { 'campagne_id': item.id }
        this._app.postData(`gestion-campagnes/eia/demarrer-campagne`, data)
          .subscribe(
            res => {
              if (res.error === false) {
                this._toastr.success(res.message);
                this.getAllCampagne();
                this._loading.stop();
              } else {
                this._toastr.error(res.message);
                this._loading.stop();
              }
            }, err => {
              this._loading.stop();
              this._toastr.error(err.error.message);
            }
          );
      }
    });
  }

  fermerCampagne(item) {
    swal.fire({
      title: `Vous allez fermer la campagne ${item.libelle}`,
      text: 'cette action est irréversible !!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FD7E14',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Non, Annuler!',
      confirmButtonText: 'Oui, fermer!'
    }).then((result) => {
      if (result.value) {
        this._loading.start();
        this.loaderText = 'Fermeture de la campagne en cours';
        const data = { 'campagne_id': item.id }
        this._app.postData(`gestion-campagnes/eia/fermer-campagne`, data)
          .subscribe(
            res => {
              if (res.error === false) {
                this._toastr.success(res.message);
                this.getAllCampagne();
                this._loading.stop();
              } else {
                this._toastr.error(res.message);
                this._loading.stop();
              }
            }, err => {
              this._loading.stop();
              this._toastr.error(err.error.message);
            }
          );
      }
    });
  }

  saveCampagne() {
    this._loading.start();
    this.loaderText = 'Enregistrement de la campagne en cours';
    const data = {
      'libelle': this.libelle,
      'date_debut': this.date_debut,
      'date_fin': this.date_fin,
      'campagne_id': this.storage.retrieve('idCampagneEiaSelected')
    }
    this._app.postData('gestion-campagnes/eia/nouvelle-campagne', data)
      .subscribe(
        res => {
          if (res.error === false) {
            this._toastr.success(res.message);
            this.rerender();
            this.activeModal.close();
            this._loading.stop();
            this.date_debut = '';
            this.date_fin = '';
            // this.getListeAnnee();
          } else {
            this._toastr.error(res.message);
            this._loading.stop();
          }
        }, err => {
          this._toastr.error(err.error.message);
        }
      );
  }

  getAllCampagne() {
    this._loading.start();
    this._app.postData('gestion-campagnes/eia/all-campagnes-active', {})
      .subscribe(
        res => {
          if (res.error === false) {
            this._loading.stop();
            this.listCampagne = res.data;
          } else {
            this._loading.stop();
          }
        }, err => {
          this._loading.stop();
        }
      );
  }

  rerender() {
    this.getAllCampagne();
  }
}
